export default __webpack_public_path__ + "static/media/sea.1eba1001.jpg";